import { useCallback } from 'react';
import { useSuspenseQuery, useQueryClient } from '@tanstack/react-query';
import queryKeys from '../../support/uiStateKeys';
import statusTypes from '../../support/statusTypes';

const dataKeys = [queryKeys.REMOVE_QUERY_ON_MODAL_CLOSE, queryKeys.STATUS];
const defaultStatus = statusTypes.IN_PROGRESS;
/**
 * status returns the current status of the component
 *
 * @returns {{ status: string, setStatus: function }}
 */
const useStatus = () => {
  const queryClient = useQueryClient();

  const { data } = useSuspenseQuery({
    queryKey: dataKeys,
    queryFn: ({ queryKey }) => queryClient.getQueryData(queryKey),
    initialData: defaultStatus,
  });

  const setStatus = useCallback(
    (newStatus) => {
      queryClient.setQueryData(dataKeys, newStatus);
    },
    [queryClient]
  );

  return {
    status: data,
    setStatus,
  };
};

export default useStatus;
